/* eslint quote-props: 0 */

import insertKeyframesRule from 'domkit/insertKeyframesRule';
const RISE_AMOUNT = 30;
const keyframesEven = {
  '0%': {
    transform: 'scale(1.1)'
  },
  '25': {
    transform: "translateY(-".concat(RISE_AMOUNT, "px)")
  },
  '50%': {
    transform: 'scale(0.4)'
  },
  '75%': {
    transform: "translateY(".concat(RISE_AMOUNT, "px)")
  },
  '100%': {
    transform: 'translateY(0) scale(1.0)'
  }
};
const keyframesOdd = {
  '0%': {
    transform: 'scale(0.4)'
  },
  '25': {
    transform: "translateY(".concat(RISE_AMOUNT, "px)")
  },
  '50%': {
    transform: 'scale(1.1)'
  },
  '75%': {
    transform: "translateY(-".concat(RISE_AMOUNT, "px)")
  },
  '100%': {
    transform: 'translateY(0) scale(0.75)'
  }
};
export const animationNameEven = insertKeyframesRule(keyframesEven);
export const animationNameOdd = insertKeyframesRule(keyframesOdd);